import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { hasReveal } from "@/lib/assessment";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function startGoogleLogin() {
  const redirectUrl = window.location.origin + "/auth/callback";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { persist } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const m = location.hash.match(/session_id=([^&]+)/);
    const sessionId = m ? decodeURIComponent(m[1]) : null;
    window.history.replaceState(null, "", window.location.pathname);
    if (!sessionId) { navigate("/login", { replace: true }); return; }
    api.post("/auth/google/session", { session_id: sessionId }).then(({ data }) => {
      persist(data);
      const u = data.user;
      if (hasReveal()) navigate("/result", { replace: true });
      else if (["admin", "super_admin"].includes(u.role)) navigate("/admin", { replace: true });
      else if (!u.onboarded) navigate("/onboarding", { replace: true });
      else if (!u.assessment_completed) navigate("/assessment", { replace: true });
      else navigate("/app/home", { replace: true });
    }).catch((e) => { toast.error(apiError(e)); navigate("/login", { replace: true }); });
  }, [location.hash, navigate, persist]);

  return <div className="flex min-h-screen items-center justify-center" data-testid="auth-callback"><Loader2 className="h-8 w-8 animate-spin text-indigo-600" /></div>;
}
